export interface RootCategory {
  id: string;
  label: string;
  entrypoint: string;
  hasSubcategories: boolean;
}

// Tab configuration with entrypoints
export const ROOT_CATEGORY_CONFIG: RootCategory[] = [
  { id: "for_you", label: "For You", entrypoint: "popular", hasSubcategories: false },
  { id: "grocery", label: "Grocery", entrypoint: "gc_grocery", hasSubcategories: false },
  { id: "super-sale", label: "Super Sale", entrypoint: "subsidy_deals", hasSubcategories: false },
  { id: "clearance", label: "Clearance", entrypoint: "high_discount", hasSubcategories: false },
  { id: "branded", label: "Brands", entrypoint: "branded", hasSubcategories: false },
  { id: "hot_sale", label: "Hot", entrypoint: "hot_sale", hasSubcategories: false },
  { id: "fast_delivery", label: "Fast Delivery", entrypoint: "fast_delivery", hasSubcategories: false },
  {
    id: "food_beverages",
    label: "Food & Beverages",
    entrypoint: "Rm9vZCwgQmV2ZXJhZ2VzICYgVG9iYWNjbw==",
    hasSubcategories: true,
  },
  { id: "media", label: "Media", entrypoint: "TWVkaWE=", hasSubcategories: true },
  { id: "health_beauty", label: "Health & Beauty", entrypoint: "SGVhbHRoICYgQmVhdXR5", hasSubcategories: true },
  { id: "baby_toddler", label: "Baby & Toddler", entrypoint: "QmFieSAmIFRvZGRsZXI=", hasSubcategories: true },
  {
    id: "apparel_accessories",
    label: "Apparel & Accessories",
    entrypoint: "QXBwYXJlbCAmIEFjY2Vzc29yaWVz",
    hasSubcategories: true,
  },
  { id: "home_garden", label: "Home & Garden", entrypoint: "SG9tZSAmIEdhcmRlbg==", hasSubcategories: true },
  { id: "toys_games", label: "Toys & Games", entrypoint: "VG95cyAmIEdhbWVz", hasSubcategories: true },
  { id: "furniture", label: "Furniture", entrypoint: "RnVybml0dXJl", hasSubcategories: true },
  { id: "electronics", label: "Electronics", entrypoint: "RWxlY3Ryb25pY3M=", hasSubcategories: true },
  { id: "office_supplies", label: "Office Supplies", entrypoint: "T2ZmaWNlIFN1cHBsaWVz", hasSubcategories: true },
  { id: "hardware", label: "Hardware", entrypoint: "SGFyZHdhcmU=", hasSubcategories: true },
  { id: "luggage_bags", label: "Luggage & Bags", entrypoint: "THVnZ2FnZSAmIEJhZ3M=", hasSubcategories: true },
  {
    id: "business_industrial",
    label: "Business & Industrial",
    entrypoint: "QnVzaW5lc3MgJiBJbmR1c3RyaWFs",
    hasSubcategories: true,
  },
  {
    id: "animals_pet_supplies",
    label: "Animals & Pet Supplies",
    entrypoint: "QW5pbWFscyAmIFBldCBTdXBwbGllcw==",
    hasSubcategories: true,
  },
  { id: "cameras_optics", label: "Cameras & Optics", entrypoint: "Q2FtZXJhcyAmIE9wdGljcw==", hasSubcategories: true },
  { id: "sporting_goods", label: "Sporting Goods", entrypoint: "U3BvcnRpbmcgR29vZHM=", hasSubcategories: true },
  {
    id: "arts_entertainment",
    label: "Arts & Entertainment",
    entrypoint: "QXJ0cyAmIEVudGVydGFpbm1lbnQ=",
    hasSubcategories: true,
  },
  { id: "vehicles_parts", label: "Vehicles & Parts", entrypoint: "VmVoaWNsZXMgJiBQYXJ0cw==", hasSubcategories: true },
  { id: "software", label: "Software", entrypoint: "U29mdHdhcmU=", hasSubcategories: true },
  {
    id: "religious_ceremonial",
    label: "Religious & Ceremonial",
    entrypoint: "UmVsaWdpb3VzICYgQ2VyZW1vbmlhbA==",
    hasSubcategories: true,
  },
];

export const GOOGLE_ROOT_CATEGORY_CONFIG: RootCategory[] = ROOT_CATEGORY_CONFIG.filter(
  ({ hasSubcategories }) => hasSubcategories
);
